//const base="http://localhost:8080/api/v1/"
//const base="http://progress.api.fbase.co.uk/api/v1/"
import base from "./base";
//const base="http://localhost:8080/api/v1/";
const aiUrl = "https://ai-chatbot-cloudrun-183968704272.us-east1.run.app/";
const company = base + "company/";
const expenses = base + "expenses/";
const sales = base + "sales/";
const client = base + "client/";
const enterpriseClient = base + "enterpriseClient/";
const options = base + "options/";
const paymentTerms = base + "payment-terms/";
const upload = base + "upload/";
const img = base + "img/";
const enterprise = base + "enterprise/";
const enterpriseCompany = base + "enterprise-company/";
const contract = base + "contract/";
const order = base + "order/";
const survey = base + "surveys/";
const notification = base + "notification/";
const publicc = base + "public/";
const riskTemplate = base + "risk-templates/";

const Url = {
	mail: expenses + "mail",
	login: base + "auth/login",
	forgotPassword: base + "auth/forgot-password",
	auth: {
		register: base + "auth/register",
	},
	ui: {
		dashboard: base + "ui/dashboard",
		userTasks: (id) => base + "ui/userTask/" + id,
		taskCountbyDate: (roleName, month, year) =>
			`${base}ui/taskCountBydate?roleName=${roleName}&month=${month}&year=${year}`,
		taskTypeCounts: (month, year) =>
			`${base}ui/taskTypeCounts?month=${month}&year=${year}`,
		data: (id) => base + "ui/" + id,
	},
	client: {
		surveyByJobId: (id) => enterpriseClient + `jobid/${id}`,
		survey: enterpriseClient + "create-survey",
		saveImage: enterpriseClient + "save-image",
		getImage: (id) => enterpriseClient + "get-image/" + id,
		verify: client + "verify",
		verifyEnterprise: client + "verify-enterprise",
		verifyContract: client + "verify-contract",
		verifyEnterpriseContract: client + "verify-enterprise-contract",
		contact: client + "contact",
		enterpriseContact: client + "enterprise-contact",
		starlinkContact: client + "starlink-contact",
		vessel: client + "vessel",
		starlinkVessel: client + "starlink-vessel",
		port: client + "port",
		getInitial: (id) => client + `initial/get/${id}`,
		signContract: client + "sign-contract",
		acceptContract: client + "approve-contract",
		signEnterpriseContract: client + "sign-enterprise-contract",
	},
	enterpriseClient: {
		verify: enterpriseClient + "verify",
		verifyContract: enterpriseClient + "verify-contract",
		contact: enterpriseClient + "contact",
		starlinkContact: enterpriseClient + "starlink-contact",
		getEnterpriseInitial: (id) => enterpriseClient + `initial/get/${id}`,
		signContract: enterpriseClient + "sign-contract",
	},
	public: {
		getEntCompanyTasks: (trackingCode, current, page) =>
			publicc + `getEntCompanyTasks/${trackingCode}/${current}/${page}`,
		getMrtCompanyTasks: (trackingCode, current, page) =>
			publicc + `getMrtCompanyTasks/${trackingCode}/${current}/${page}`,
		getMrtCompanyTasksDTO: (trackingCode, current, page) =>
			publicc +
			`getMrtCompanyCurrentTasksDTO/${trackingCode}/${current}/${page}`,
		getEntCompanyTasksDTO: (trackingCode, current, page) =>
			publicc +
			`getEntCompanyCurrentTasksDTO/${trackingCode}/${current}/${page}`,
		getCompanyIdByTrackingCode: (trackingCode) =>
			`${publicc}company?companyTrackingCode=${trackingCode}`,
		getMrtTaskTypeCounts: (year, month, companyId) => {
			const monthParam = month ? `&month=${month}` : "";
			return `${publicc}getMrtTaskTypeCounts?year=${year}${monthParam}&company_id=${companyId}`;
		},
		getEntTaskTypeCounts: (year, month, companyId) => {
			const monthParam = month ? `&month=${month}` : "";
			return `${publicc}getEntTaskTypeCounts?year=${year}${monthParam}&company_id=${companyId}`;
		},

		getMrtCompanyTaskByVessel: (companyId, year, month) => {
			const monthParam = month ? `&month=${month}` : "";
			return `${publicc}getMrtCompany/getTaskByVessel?company_id=${companyId}&year=${year}${monthParam}`;
		},
		getEntCompanyTaskByState: (companyId, year, month) => {
			const monthParam = month ? `&month=${month}` : "";
			return `${publicc}getEntCompany/getTaskByState?company_id=${companyId}&year=${year}${monthParam}`;
		},
		getCompanyTrackingCode: (email) => publicc + `gettrackingcode/${email}`,
	},
	sales: {
		init: sales + "init",
		enterpriseInit: sales + "enterprise-init",
		starlinkInit: sales + "starlinkInit",
		sendContract: sales + "contract/send",
		sendEnterpriseContract: sales + "enterpriseContract/send",
		getInitDTO: (id) => sales + "initialDTO/get/" + id,
		getAllInitDTO: (current, page) =>
			sales + `initialDTO/get-all/${current}/${page}`,
		getAllEnterpriseInitDTO: (current, page) =>
			sales + `initialDTO/get-all-enterprise/${current}/${page}`,
		getAllMarine: (pending, page) =>
			sales + `initial/get-all-marine/${pending}/${page}`,
		getAllEnterprise: (pending, page) =>
			sales + `initial/get-all-enterprise/${pending}/${page}`,
		getAll: (current, page) => sales + `initial/get-all/${current}/${page}`,
		getInitial: (id) => sales + `initial/get/${id}`,
		getInitialContract: (id) => sales + `initial-contract/get/${id}`,
		jobAdvice: (id) => sales + `jobAdvice/${id}`,
		getjobAdvice: (id) => sales + `getJobAdvice/${id}`,
		getEnterpriseInitial: (id) => sales + `initial/get-enterprise/${id}`,
		saveRequirements: sales + "requirements/save",
		saveEnterpriseRequirements: sales + "enterpriseRequirements/save",
		saveRisk: sales + "risk/save",
		saveEnterpriseRisk: sales + "enterpriseRisk/save",
		getAllRiskItems: sales + "riskItems",
		saveContractBilling: sales + "contract/save-billing",
		saveEnterpriseContractBilling: sales + "enterpriseContract/save-billing",
		saveContractTerms: sales + "contract/save-terms",
		saveEnterpriseContractTerms: sales + "enterpriseContract/save-terms",
		saveContractReview: sales + "contract/save-review",
		saveEnterpriseContractReview: sales + "enterpriseContract/save-review",
		submitContractForApproval: sales + "initial/submit-for-approval",
		updatePaymentTerm: sales + "initial/update-payment-term-status",
		getContractsByStatus: (status) =>
			sales + `initial/by-payment-term-status/${status}`,
	},
	enterprise: {
		dashboard: enterprise + "dashboard",
		taskCountbyDate: (roleName, month, year) =>
			`${enterprise}dashboard/taskCountBydate?roleName=${roleName}&month=${month}&year=${year}`,
		taskTypeCounts: (month, year) =>
			`${enterprise}dashboard/taskTypeCounts?month=${month}&year=${year}`,
		userTasks: (id) => enterprise + "userTask/" + id,
		requirements: (id) => enterprise + "requirements/" + id,
		risk: (id) => enterprise + "risk/" + id,
		contract: (id) => enterprise + "contract/" + id,
		saveEngineer: enterprise + "save-engineer",
		saveTask: enterprise + "save-task",
		save: enterprise + "update-task",
		saveTaskSales: enterprise + "task/save-sales",
		knowledgeBase: enterprise + "knowledge-base",
		taskList: (current, page) => enterprise + `task-list/${current}/${page}`,
		userTaskList: (current, page, q = "") =>
			enterprise +
			`user-task-list/${current}/${page}${
				q ? `?q=${encodeURIComponent(q)}` : ""
			}`,
		getTask: (id) => enterprise + `get-task/${id}`,
		closedTasks: (page) => enterprise + `task/closed/${page}`,
		taskRange: base + "enterprise/task-range",
		milestones: enterprise + "milestones",
		saveMilestone: enterprise + "save-milestone",
		milestoneTemplate: enterprise + "milestone-template",
		allTemplates: enterprise + "all-templates",
		saveMilestones: enterprise + "save-milestones",
		templatebyUser: (userid) => enterprise + "user-templates/" + userid,

		// saveMilestone: enterprise + "save-milestone",
		taskCompleted: enterprise + `completed`,
		taskTemplates: (ownerId, taskId) =>
			enterprise + `task-templates/${ownerId}/${taskId}`,
	},
	enterpriseCompany: {
		search: (keyword, pg) => enterpriseCompany + "search/" + keyword + "/" + pg,
		allCompany: enterpriseCompany + "get-all",
		get: {
			page: (pg) => enterpriseCompany + "get-page/" + pg,
			logo: (companyId) => enterpriseCompany + "get-logo/" + companyId,
		},
		getCompany: (companyId) => enterpriseCompany + "get/" + companyId,
		availabilityStatus: enterpriseCompany + "availability-status",
		requiredStatus: enterpriseCompany + "required-status",
		clientDesignations: enterpriseCompany + "client-designations",
		clientRoles: enterpriseCompany + "client-roles",
		contacts: (companyId) => enterpriseCompany + "company-contact/" + companyId,
		save: {
			logo: enterpriseCompany + "save-logo",
			company: enterpriseCompany + "save",
		},
	},
	contract: {
		get: (id) => contract + `get-template/${id}`,
		save: contract + "save",
		saveEnterprise: contract + "save-enterprise",
		saveClause: contract + "save-clause",
		getAllClause: contract + "get-all-clause",
		getAllTemplate: contract + "get-all-template",
		getAllEnterpriseTemplate: contract + "get-all-enterprise-template",
		getSelectByTaskType: (countryId) => contract + `get-select/${countryId}`,
		getContractByCountry: (countryId) => contract + `get-contract/${countryId}`,
		getSelectEnterpriseByTaskType: (taskTypeId) =>
			contract + `get-enterprise-select/${taskTypeId}`,
		getEnterpriseContractByCountry: (countryId) =>
			contract + `get-enterprise-contract/${countryId}`,

		saveOrderList: contract + "save-order-list",
		getContractCountries: contract + "contract-countries",
		editClause: (clauseId) => contract + `edit-clause/${clauseId}`,
		deleteClause: (clauseId) => contract + `delete-clause/${clauseId}`,
	},
	options: {
		periods: options + "periods",
		provisionService: (serviceId) => options + "provision-service/" + serviceId,
	},
	paymentTerms: {
		periods: paymentTerms + "periods",
		// provisionService: (serviceId) => options + "provision-service/" + serviceId,
	},
	upload: {
		save: upload + "save",
		get: (id) => upload + "get/" + id,
	},
	img: {
		get: (id) => img + "get/" + id,
		thumb: (id) => img + "thumb/" + id,
		getSize: (id, width) => img + "get/" + id + (width ? "/" + width : ""),
	},
	company: {
		all: company + "get-all",
		allDTO: company + "get-all-dto",
		vesselDTO: (companyId) => company + `get-vessel-dto/${companyId}`,
		get: {
			page: (pg) => company + "get-page/" + pg,
			logo: (companyId) => company + "get-logo/" + companyId,
		},
		search: (keyword, pg) => company + "search/" + keyword + "/" + pg,
		vessel: (companyId) => company + "vessels/" + companyId,
		vesselClasses: company + "vessel-classes",
		vesselTypes: company + "vessel-types",
		vesselWeights: company + "vessel-weights",
		vesselMaterials: company + "vessel-materials",
		vesselPowers: company + "vessel-power",
		availabilityStatus: company + "availability-status",
		requiredStatus: company + "required-status",
		clientDesignations: company + "client-designations",
		clientRoles: company + "client-roles",
		contacts: (companyId) => company + "company-contact/" + companyId,
		saveCompanyContact: company + "company-contact/save",
		save: {
			logo: company + "save-logo",
		},
	},
	expenses: {
		save: expenses + "save",
		saveEnterprise: expenses + "save-enterprise",
		saveApproval: expenses + "save-expense-approval",
		savePayment: expenses + "save-expense-payment",
		saveSchedule: expenses + "save-expense-schedule",
		get: (id) => expenses + `get/${id}`,
		delete: (id) => expenses + `delete/${id}`,

		getTaskExpenses: (id) => expenses + `get-task-expenses/${id}`,
		getEnterprise: (id) => expenses + `get-enterprise/${id}`,
		getEnterpriseTaskExpenses: (id) =>
			expenses + `get-enterprise-task-expenses/${id}`,
		submit: (id, staffId) => expenses + `submit/${id}/${staffId}`,
		tasks: (approved, page) => expenses + `tasks/${approved}/${page}`,
		enterpriseTasks: (approved, page) =>
			expenses + `enterprise-tasks/${approved}/${page}`,
		approvedTasks: (isPaid, page) =>
			expenses + `approved-tasks/${isPaid}/${page}`,
		approvedEnterpriseTasks: (isPaid, page) =>
			expenses + `approved-enterprise-tasks/${isPaid}/${page}`,
		tasksdto: (approved, page) => expenses + `task-dto/${approved}/${page}`,
		completed: (page) => expenses + `task-dto/completed/${page}`,
		disapproved: (page) => expenses + `task-dto/disapproved/${page}`,
		enterpriseTasksdto: (approved, page) =>
			expenses + `enterprise-task-dto/${approved}/${page}`,
		enterpriseCompleted: (page) =>
			expenses + `enterprise-task-dto/completed/${page}`,
		enterpriseDisapproved: (page) =>
			expenses + `enterprise-task-dto/disapproved/${page}`,
	},
	order: {
		saveToInventory: order + "maritime-inventory",
		saveEnterpriseToInventory: order + "enterprise-inventory",
	},
	survey: {
		survey: survey,
		surveyList: survey + "list",
		updateSurvey: (id) => survey + `${id}`,
		surveyByJobId: (id) => survey + `jobid/${id}`,
		getEquipments: survey + "equipment",
		addEquipment: survey + "equipment",
		createReport: survey + "report",
		updateReport: (id) => survey + `report/${id}`,
		getReportByJobId: (id) => survey + `report/jobid/${id}`,
	},
	notification: {
		create: notification + "PopUpNotification",
		getAll: notification + "PopUpNotification",
		getById: (id) => notification + `PopUpNotification/${id}`,
		update: (id) => notification + `PopUpNotification/${id}`,
		delete: (id) => notification + `PopUpNotification/${id}`,
		getByVisibility: (visibility) => notification + `visibility/${visibility}`,
		current: notification + `PopUpNotification/current`,
	},
	riskTemplate: {
		getQuestionTypes: riskTemplate + "Questiontype",

		createQuestion: riskTemplate + "risk-questions",

		// Get all questions
		getAllQuestions: riskTemplate + "risk-questions",

		// Get a question by ID
		getQuestionById: (id) => riskTemplate + `risk-questions/${id}`,

		// Update a question
		updateQuestionById: (id) => riskTemplate + `risk-questions/${id}`,

		// Delete a question
		deleteQuestionById: (id) => riskTemplate + `risk-questions/${id}`,

		//create a Template
		createTemplate: riskTemplate + "createTemplate",

		//get all templates
		getTemplates: riskTemplate + "get-risktemplate",

		//update template by id
		updateTemplateById: (id) => riskTemplate + `get-risktemplate/${id}`,

		//update templatr by id
		deleteTemplateById: (id) => riskTemplate + `risk-template/${id}`,
	},

	chatBot: {
		query: aiUrl + "query",
		thread: aiUrl + "thread",
		history: aiUrl + "history",
	},
	//company:base+"company/get-all",
	//companyPage:(page)=>base+"company/get-page/"+page,

	countries: base + "staff/countries",
	allStaff: base + "staff/get-all-staff",
	staffWithTask: base + "staff/with-tasks",
	staffAddRole: base + "staff/add-role",
	staffRemoveRole: base + "staff/remove-role",
	updateStaff: (id) => base + "staff/" + id,
	RemoveStaff: base + "staff/remove-staff",
	updateProfile: base + "staff/update-profile",
	changePassword: base + "staff/change-password",
	staffWithTaskRole: (rolename) => base + "staff/with-tasks/" + rolename,
	staffByrole: (rolename) => base + "staff/get-role/" + rolename,
	staffById: (id) => base + "staff/" + id,
	allSpecializations: base + "staff/all-specializations",
	addSpecializations: base + "staff/add-specializations",
	selectStaffByRole: (rolename) => base + "select/staff-by-role/" + rolename,
	taskType: base + "task/types",
	taskRange: base + "task/task-range",
	milestones: base + "task/milestones",
	saveMilestones: base + "task/save-milestones",
	saveMilestone: base + "task/save-milestone",
	saveTaskMilestone: base + "task/save-task-milestone",
	deleteMilestone: (id) => base + "task/delete-milestone/" + id,
	requirements: (id) => base + "task/requirements/" + id,
	risk: (id) => base + "task/risk/" + id,
	taskContract: (id) => base + "task/contract/" + id,

	milestoneTemplate: base + "task/milestone-template",
	templateByuser: (userid) => base + "task/user-templates/" + userid,
	allTemplate: base + "task/all-templates",
	deleteTemplate: (templateid) => base + "task/delete-template/" + templateid,
	getCompany: (companyId) => base + "company/get/" + companyId,
	vessels: base + "company/vessels",
	saveCompany: base + "company/save",
	taskTemplates: (companyid, taskId) =>
		base + `task/task-templates/${companyid}/${taskId}`,
	allEquipment: base + "equipment/all",
	saveTask: base + "task/save",
	saveTaskSales: base + "task/save-sales",
	taskCompleted: base + "task/completed",
	taskApproval: base + "task/approval",

	userTasks: (current, page, q = "") =>
		base +
		`task/user-task/${current}/${page}${
			q ? `?q=${encodeURIComponent(q)}` : ""
		}`,

	closedTasks: (page) => base + `task/closed/${page}`,

	taskMilestone: base + "task/task-milestone",
	task: (id) => base + `task/${id}`,
	trashedTasks: (page) => base + `task/trashed/${page}`,
	countTask: (id) => base + `task/count/${id}`,
	getTaskByTracking: (tracking) => base + `task/get-by-tracking/${tracking}`,
	taskByTracking: (tracking) => base + `public/task-by-tracking/${tracking}`,
	saveFbByTracking: (tracking) => base + `public/feedback/${tracking}`,
	checkFeedbackExists: (tracking) => base + `public/feedback/check/${tracking}`,
	getFeedbackQuestions: () => base + "public/feedback/questions",
	publicMilestones: base + `public/milestones`,
	saveReport: base + "report/save",
	saveInitialImages: base + "report/saveInitialImages",
	saveInitialImage: base + "report/saveInitialImage",
	deleteInitialImage: (id) => base + `report/deleteInitialImage/${id}`,
	saveLogImages: base + "report/saveLogImages",
	saveLogImage: base + "report/saveLogImage",
	deleteLogImage: (id) => base + `report/deleteLogImage/${id}`,
	getTaskReport: (taskId) => base + `report/by-task/${taskId}`,
	saveReportLog: base + "report/saveLog",
	getEquipmentReport: (equipmentId) =>
		base + `report/by-equipment/${equipmentId}`,
	getNotifications: (userId, view, page) =>
		base +
		`notification/get/${userId}?page=${page}${
			view !== null && view !== undefined ? `&view=${view}` : ""
		}`,
	getCompanyNotifications: (companyId, isEnt, view, page) =>
		base +
		`public/get-company-notifications/${companyId}/${isEnt}?page=${page}${
			view !== null && view !== undefined ? `&view=${view}` : ""
		}`,
	getNotification: (id, userId) =>
		base + `notification/get-details/${id}/${userId}`,
	getCompanyNotification: (id, companyId, isEnt) =>
		base +
		`public/get-company-notification-details/${id}/${companyId}/${isEnt}`,
	countNotifications: (userId, view) =>
		base +
		`notification/count/${userId}?${
			view !== null && view !== undefined ? `&view=${view}` : ""
		}`,
	countCompanyNotifications: (companyId, isEnt, view) =>
		base +
		`public/count-company-notifications/${companyId}/${isEnt}?${
			view !== null && view !== undefined ? `&view=${view}` : ""
		}`,
	markAllAsRead: (userId) =>
		base + `notification/mark-all-notifications-read?userId=${userId}`,

	markCompanyAsRead: (companyId, isEnt) =>
		base +
		`public/mark-all-notifications-read?companyId=${companyId}&isEnt=${isEnt}`,
	knowledgeBase: base + `knowledgeBase`,
	contact: (companyId, companyType) =>
		base + `Contact/${companyId}/${companyType}`,
	updateContact: (contactId) => base + `Contact/${contactId}`,
};
export default Url;
